// Where the Hapday app account is created after a payment. A test flow (window.isTestFlow, set in index.html for
// a development build, a pk_test_ Stripe key, dev.hapday.ai or localhost) talks to the dev backend, like the Gulp
// funnels' /flow-dev/ (QA-95: dev.hapday.ai with the public test card made production accounts with Pro).
export const PRODUCTION_APP_API = 'https://hapday.app/api/v1';
export const DEV_APP_API = 'https://dev.hapday.app/api/v1';

export const isTestFlow = () => typeof window !== 'undefined' && window.isTestFlow === true;

export const appApiBase = (testFlow = isTestFlow()) => (testFlow ? DEV_APP_API : PRODUCTION_APP_API);

export const appRegistrationUrl = (testFlow = isTestFlow()) => `${appApiBase(testFlow)}/auth/w2w/reg/`;

export const appUpsellUrl = (testFlow = isTestFlow()) => `${appApiBase(testFlow)}/tasks/w2w/purchasing/`;

// Sign-up stores the email lowercased; the upsell call must find the same account (QA-94).
export const appEmail = (email) => String(email || '').trim().toLowerCase();

// PayPal ids the sign-up sends as `paypal_id` (like the Gulp funnels): the main PayPal subscription, then the PayPal
// upsell subscriptions/orders bought before the sign-up. The server gives Pro only after PayPal confirms one of them,
// so without this list a PayPal buyer gets an account without Pro (#116). Empty when nothing was paid with PayPal.
export const appPaypalIds = (sessionInfo, upsellPaypalIds = []) => {
  const main = sessionInfo?.subscription?.type === 'paypal' ? [sessionInfo.subscription.id] : [];
  const ids = [...main, ...(Array.isArray(upsellPaypalIds) ? upsellPaypalIds : [])]
    .map((id) => (id === null || id === undefined ? '' : String(id).trim()))
    .filter(Boolean);
  return [...new Set(ids)];
};

// userData after a PayPal upsell: its subscription or order id is kept for the sign-up.
export const withUpsellPaypalId = (userData, paypalId) => {
  const id = paypalId === null || paypalId === undefined ? '' : String(paypalId).trim();
  const ids = userData?.upsalePaypalIDs || [];
  return id && !ids.includes(id) ? [...ids, id] : ids;
};
